import { wfhRulesDb } from "./dbs";

class WfhCountryInfoService {
  db = wfhRulesDb;
  // todo get this from env
  globalWftInfoTable = this.db("tblc2wjLuc3p9r398");

  async getAllCountryInfoRecords() {
    const response = await this.globalWftInfoTable.select().all();

    return response.map(({ fields }) => fields);
  }
}

export const wfhCountryInfoService = new WfhCountryInfoService();
